export default {
  methods: {
    toggleLeftSidenav() {
      this.$refs.leftSidenav.toggle();
    },
    open(ref) {
    },
    close(ref) {
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/sidenav.js